import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Unstable_Grid2/Grid2";
import TabPanel, { TabPanelProps } from "@mui/lab/TabPanel";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  ListSubheaderProps,
  Paper,
  Typography,
} from "@mui/material";

import { SilhouetteIcon } from "@robin/common";

import { PatientData } from "../models/patient-data";
import { HorizontalStack } from "./primitives/Stacks";
import { Badge } from "./primitives/Badge";

const listSubheaderProps: ListSubheaderProps = {
  sx: {
    bgcolor: "background.default",
    borderBottom: "0.75px solid",
    borderColor: "divider",
    color: "text.primary",
    fontWeight: 500,
  },
};

export const StrengthsTab: React.FC<TabPanelProps & { data: PatientData }> = ({
  data: { data },
  ...tabPanelProps
}) => {
  const { t } = useTranslation();

  const hasStrengths = data?.strengths?.length > 0;

  return (
    <TabPanel {...tabPanelProps}>
      <Paper sx={{ overflow: "hidden" }} variant="outlined">
        <List
          sx={{ maxHeight: 400, overflow: "auto", scrollbarWidth: "thin" }}
          dense
          disablePadding
          subheader={
            <ListSubheader {...listSubheaderProps}>
              <HorizontalStack alignItems="center" spacing={1}>
                <span>{t("tabs.more.strengths-label")}</span>
                <Badge
                  size="small"
                  variant="outlined"
                  label={data?.strengths?.length || 0}
                />
              </HorizontalStack>
            </ListSubheader>
          }
        >
          {hasStrengths ? (
            data.strengths.map((strength, num) => (
              <ListItem
                key={strength.id}
                divider={num < data?.strengths?.length - 1}
              >
                <ListItemIcon>
                  <SilhouetteIcon
                    fontSize="small"
                    sx={{ color: "text.disabled" }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Grid
                      alignItems="center"
                      container
                      spacing={{ xs: 0.5, md: 2 }}
                    >
                      <Grid xs={12} md>
                        <Typography variant="body2">
                          {strength.title}
                        </Typography>
                      </Grid>
                    </Grid>
                  }
                />
              </ListItem>
            ))
          ) : (
            <ListItem>
              <ListItemText
                primary={t("tabs.more.strengths-no-data")}
                primaryTypographyProps={{
                  align: "center",
                  color: "text.secondary",
                }}
              />
            </ListItem>
          )}
        </List>
      </Paper>
    </TabPanel>
  );
};

export default StrengthsTab;
